/**
 * Company Details Utility
 * Reads company branding details from environment variables (.env.development)
 * Supports both local files and external URLs for logo and favicon
 */

const getCompanyLogo = () => {
  const logoPath = process.env.REACT_APP_COMPANY_LOGO || "companyLogo.svg";
  
  // If it's an external URL (http or https), return it as-is
  if (logoPath.startsWith('http://') || logoPath.startsWith('https://')) {
    return logoPath;
  }
  
  // Otherwise, try to load from local assets/images folder
  try {
    return require(`assets/images/${logoPath}`).default || require(`assets/images/${logoPath}`);
  } catch (error) {
    // Fallback to default logo if file not found
    return require('assets/images/companyLogo.svg').default || require('assets/images/companyLogo.svg');
  }
};

const getCompanyFavicon = () => {
  const faviconPath = process.env.REACT_APP_COMPANY_FAVICON || "/favicon.ico";
  
  // If it's an external URL (http or https), return it as-is
  if (faviconPath.startsWith('http://') || faviconPath.startsWith('https://')) {
    return faviconPath;
  }
  
  // Otherwise return as local path
  return faviconPath;
};

export const companyDetails = {
    companyName: process.env.REACT_APP_COMPANY_NAME || "ITER-RentnGo-SuperAdmin",
    companyLogo: getCompanyLogo(),
    favicon: getCompanyFavicon()
}